export default __webpack_public_path__ + "static/media/RightArrowBlue.df44c34f.svg";